import React, { FC, useCallback } from 'react';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import FinanceProductTabs from './FinanceProductTabs';
import reactiveVarsService from '../../../../../../gqlCommon/service/reactiveVarsService';
import { hasFinanceProviderErrorVar } from '../../../../../../gqlCommon/graphql/cache';
import { useReactiveVar } from '@apollo/client';

interface IFinanceProductTabsContainerProps {
  setIsFinCalcSpcModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
  isCash: boolean;
  loading?: boolean;
}

const FinanceProductTabsContainer: FC<IFinanceProductTabsContainerProps> = ({
  setIsFinCalcSpcModalOpen,
  isCash,
  loading,
}) => {
  const { configuration } = useWidgetContext();
  const hasFinanceProviderError = useReactiveVar(hasFinanceProviderErrorVar);

  const onFinanceProductChange = useCallback(
    (_e, value) => {
      switch (value) {
        case 'finance':
          setIsFinCalcSpcModalOpen(true);
          break;
        case 'cash':
          reactiveVarsService.resetFinanceFormInput(configuration.dimensions);
          break;
        default:
          break;
      }
    },
    [setIsFinCalcSpcModalOpen, configuration],
  );

  return (
    <FinanceProductTabs
      disabled={loading}
      isCash={isCash}
      onChange={onFinanceProductChange}
      financeDisabled={hasFinanceProviderError}
    />
  );
};

export default FinanceProductTabsContainer;
